import React from 'react'
import MattBioPic from "../assets/images/Matt_bio.jpg"

function Bio (props) {

    const ref = React.useRef(null)

    React.useEffect(() => {
        props.attach(ref.current)
        }, [])

    return (
        <div ref={ref} id="bio" className="w-full less-than-md:block md:grid md:grid-cols-5 md:grid-rows-6 bg-cover bg-gradient-to-r from-gray-900 to-gray-800 text-white font-sans less-than-md:text-center less-than-md:py-12 less-than-md:px-12">
            <div className="md:col-start-2 md:col-end-4 md:row-start-2 md:row-end-6 md:overflow-hidden">
                <span className="text-center text-5xl text-shadow-lg tracking-widest font-semibold"><p>BIO</p></span>
                <br className="md:hidden"/>
                <span className="less-than-md:text-sm">
                    <text className="less-than-md:text-center font-semibold">Hey there! I'm Matt, and I'm currently working towards earning my Master's in Computer Science.</text><br/>
                    <br className="md:hidden"/>
                    The first time I got a taste for software development - starting with an ambitious vision, 
                    breaking that vision down into concisely defined chunks, researching them, and relentlessly attacking them, 
                    until I had something tangible in front of me that I created... I couldn't get enough!
                    Keeping up minute to minute on emerging modern technologies is what gives me an edge.
                    I'm a lifelong music student as well, and I believe in a well-rounded approach to both programming and life.
                    I've created some cool things by myself, but I love working as part of a team. 
                    Being surrounded by other smart people who are excited about programming is half the fun for me, and I believe that everyone has something to teach someone else, whether they're a beginner, or a master.
                </span>
            </div>
            <div className="md:col-start-4 md:col-end-5 md:row-start-2 md:row-end-6 md:pl-8 overflow-hidden">
                <span>
                <br className="md:hidden"/>
                    <p><img src={MattBioPic} className="rounded-full border-4 border-yellow-100 less-than-md:h-1/2 less-than-md:w-1/2 less-than-md:block less-than-md:m-auto" /></p>
                    <br className="md:hidden" />
                    <p className="pt-2 less-than-md:text-sm">
                        <text className="font-semibold">Age:</text>
                        <br/>29<br/>
                        <text className="font-semibold">Location:</text>
                        <br/>NYC Metro Area<br/>
                        <text className="font-semibold">Other Interests:</text>
                        <br/>Guitar, singing, sports, fitness, yoga, cooking, reading
                    </p>
                </span>
            </div>
        </div>
    )
}

export default Bio
